import React, {Component} from 'react';
import spinner from '../assets/loader.svg';

class Loader extends Component {

    render() {
        return (
            <div><img src={spinner} className="spinner" alt="Loading..." /></div>
        );
    }
}

export default Loader;



// WEBPACK FOOTER //
// ./src/components/Loader.js